import { Divider, Radio, TextField, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { QuestionCard, itemStyle } from "../mobilePreview.style";
import { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

type Props = {
  currentQuestion: any;
};

const RadioFieldPreview = ({ currentQuestion }: Props) => {
  const [value, setValue] = useState();
  const { choices } = currentQuestion;

  return (
    <>
      <Box sx={QuestionCard}>
        {choices.map((choice: any, index: number) => (
          <Stack key={choice?.id}>
            <Box sx={itemStyle}>
              <Typography variant="subtitle1">{choice.label}</Typography>
              <Radio
                onClick={() => {
                  setValue(choice?.value);
                }}
                checked={choice?.value === value}
                icon={
                  <RadioButtonUncheckedIcon
                    sx={{ fontSize: 24, color: "gray" }}
                  />
                }
                checkedIcon={
                  <CheckCircleIcon sx={{ fontSize: 24, color: "primary" }} />
                }
              />
            </Box>
            {choice?.isOther && choice?.value === value && (
              <Box>
                <TextField fullWidth placeholder="Type here" sx={{ mb: 2 }} />
                <Typography variant="body2" color={"#d32f2f"}>
                  Please enter a valid input
                </Typography>
              </Box>
            )}
            {index !== choices.length - 1 && <Divider />}
          </Stack>
        ))}
      </Box>
    </>
  );
};
export default RadioFieldPreview;
